import React, { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';
import api from '../../api/apiClient';

const OrgFaqPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.faqs.list({ audience: 'ORG_ADMIN', is_published: '1' });
        if (response.data?.success) {
          setFaqs(response.data.data || []);
        } else {
          setError('Failed to load FAQs');
        }
      } catch (err) {
        console.error('OrgFaqPage error:', err);
        setError('Failed to load FAQs');
      } finally {
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  return (
    <div className="p-3 sm:p-6 md:p-8 bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
          <div>
            <h3 className="fw-bold mb-0 text-xl sm:text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Organization Admin FAQs
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Answers to common questions for organization administrators using Enable LXP.
            </p>
          </div>
        </div>

        {loading && (
          <div className="text-center py-6">
            <div className="animate-spin h-8 w-8 border-4 border-purple-600 border-t-transparent rounded-full mx-auto"></div>
          </div>
        )}

        {error && !loading && (
          <div className="mb-3 p-3 rounded bg-red-50 border border-red-100 text-red-700">{error}</div>
        )}

        {!loading && !error && faqs.length === 0 && (
          <div className="text-center py-6">
            <FaQuestionCircle className="text-gray-300 mb-3" style={{ fontSize: '3rem' }} />
            <p className="text-gray-500">No FAQs are available yet. Please check back later.</p>
          </div>
        )}

        {!loading && !error && faqs.length > 0 && (
          <Accordion alwaysOpen className="mt-4">
            {faqs
              .slice()
              .sort((a, b) => a.position - b.position || new Date(a.createdAt || 0) - new Date(b.createdAt || 0))
              .map((item, index) => (
                <Accordion.Item eventKey={String(item.id || index)} key={item.id || index} className="mb-2 border border-gray-200 rounded-lg">
                  <Accordion.Header className="bg-gray-50 hover:bg-gray-100 transition-colors rounded-t-lg">
                    <span className="font-semibold text-gray-800">{item.question}</span>
                  </Accordion.Header>
                  <Accordion.Body className="bg-white rounded-b-lg">
                    <div className="prose max-w-none text-gray-700" dangerouslySetInnerHTML={{ __html: item.answer_html || '' }} />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
          </Accordion>
        )}
      </div>
    </div>
  );
};

export default OrgFaqPage;
